import ProductId from '@/modules/common/common/models/DXP/ProductId'

export default class GetProductRequest {
  language: string
  products: ProductId[]

  constructor(data: any) {
    this.language = data.language
    this.products = data.products?.map((p: any) => new ProductId(p))
  }
}
